import React from "react";
import { Heading } from "../../Heading";
export const SectionItem = ({ iconUrl, content, title }) => (React.createElement("div", { className: "section-item__root" },
    React.createElement(Heading, { design: "h3-semi-bold-small" }, title),
    React.createElement("div", { className: "content-wrapper", dangerouslySetInnerHTML: {
            __html: content,
        }, style: { "--background-image-url": `url(${iconUrl})` } })));
